// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eAzeI","_2":"styles__2__rdWyt","_1":"styles__1__g9hm1","switchItem":"styles_switchItem__7lOtK"};